import { render, staticRenderFns } from "./moveToBudget.vue?vue&type=template&id=97cef610&"
import script from "./moveToBudget.vue?vue&type=script&lang=js&"
export * from "./moveToBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports